// Based on Kyoto Regular, generated with https://themera.vercel.app/
const warningColorScheme = {
  50: '#FDE8EA',
  100: '#F9BDC3',
  200: '#F6939D',
  300: '#F26976',
  400: '#EE3E50',
  500: '#EB1429',
  600: '#BC1021',
  700: '#8D0C19',
  800: '#5E0811',
  900: '#2F0408'
};
export default warningColorScheme;